export default __webpack_public_path__ + "firebase-messaging-compat.js";